import api from './api';

const salesQuotationService = {
  // Get all sales quotations with pagination and filters
  getAllSalesQuotations: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Add pagination parameters
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      
      // Add filter parameters
      if (params.search) queryParams.append('search', params.search);
      if (params.status) queryParams.append('status', params.status);
      if (params.customer) queryParams.append('customer', params.customer);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.excludeStatus) queryParams.append('excludeStatus', params.excludeStatus);
      
      const response = await api.get(`/sales-quotations?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching sales quotations:', error);
      throw error;
    }
  },

  // Get sales quotation by ID
  getSalesQuotationById: async (id) => {
    try {
      const response = await api.get(`/sales-quotations/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching sales quotation:', error);
      throw error;
    }
  },

  // Create new sales quotation
  createSalesQuotation: async (quotationData) => {
    try {
      const response = await api.post('/sales-quotations', quotationData);
      return response.data;
    } catch (error) {
      console.error('Error creating sales quotation:', error);
      throw error;
    }
  },

  // Update sales quotation
  updateSalesQuotation: async (id, quotationData) => {
    try {
      const response = await api.put(`/sales-quotations/${id}`, quotationData);
      return response.data;
    } catch (error) {
      console.error('Error updating sales quotation:', error);
      throw error;
    }
  },

  // Delete sales quotation (soft delete)
  deleteSalesQuotation: async (id) => {
    try {
      const response = await api.delete(`/sales-quotations/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting sales quotation:', error);
      throw error;
    }
  },

  // Get sales quotation statistics
  getSalesQuotationStats: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      
      const response = await api.get(`/sales-quotations/stats?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching sales quotation stats:', error);
      throw error;
    }
  },

  // Generate quotation number (get current value for display)
  getCurrentQuotationNumber: async () => {
    try {
      const response = await api.get('/auto-increment/SALES-QUOTATION');
      return response.data;
    } catch (error) {
      console.error('Error fetching current quotation number:', error);
      throw error;
    }
  },

  // Get next quotation number (for creating new quotation)
  getNextQuotationNumber: async () => {
    try {
      const response = await api.post('/auto-increment/SALES-QUOTATION/next');
      return response.data;
    } catch (error) {
      console.error('Error getting next quotation number:', error);
      throw error;
    }
  }
};

export default salesQuotationService;

